import { Component } from 'react';

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('AMR page rendering failed', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="app-error" role="alert">
          <span className="eyebrow">Adriatic Masterpiece Residence</span>
          <h1>The page could not be displayed</h1>
          <p>Please return to the home page and try opening this section again.</p>
          <a className="button" href="/">Return to the home page</a>
        </main>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
